import { FC } from 'react'
import MenuItemCard from "./MenuItemCard";

import type { MenuItems } from "../../../types/menuItemTypes";

const MenuItemGrid: FC<MenuItems> = ({ menuItems = [] }) => {
  return (
    <div className="grid md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {menuItems.map((mi) => <MenuItemCard key={mi.id} menuItem={mi} />)}
    </div>
  );
}

export default MenuItemGrid;
